import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class DatagridEventEmitter {

	constructor() {
	}

	public click = new EventEmitter<any>();
}


// WEBPACK FOOTER //
// ./src/services/datagrid-event-emitter.ts